/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 文字列自動変換方式
 */
export type FormPagePropertyItemStringConvertRule = 'fullToHalf' | 'toHalfLower' | 'halfToFull' | 'toHalfKatakana' | 'toFullKatakana' | 'toFullHiragana';

export const FormPagePropertyItemStringConvertRule = {
    FullToHalf: 'fullToHalf' as FormPagePropertyItemStringConvertRule,
    ToHalfLower: 'toHalfLower' as FormPagePropertyItemStringConvertRule,
    HalfToFull: 'halfToFull' as FormPagePropertyItemStringConvertRule,
    ToHalfKatakana: 'toHalfKatakana' as FormPagePropertyItemStringConvertRule,
    ToFullKatakana: 'toFullKatakana' as FormPagePropertyItemStringConvertRule,
    ToFullHiragana: 'toFullHiragana' as FormPagePropertyItemStringConvertRule
};

